import React, { useState } from 'react';
import { Button } from '@/components/shadcn/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/shadcn/ui/card';
import { Input } from '@/components/shadcn/ui/input';
import { Label } from '@/components/shadcn/ui/label';
import { Auth, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase'; // Importando a instância auth do firebase
import { useNavigate } from 'react-router-dom'; // Para navegação após o login
import pkg from '../../../package.json'
import useLogin from '@/hook/useLogin';
import { AuthProvider } from '@/context/AuthContext';

interface SignInProps {
  auth: Auth;
}
import { useAuthContext } from '@/context/AuthContext';

const SignIn: React.FC<SignInProps> = () => {
  const { login } = useAuthContext(); // Usa o contexto
  const navigate = useNavigate();
  const appVersion = pkg.version;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    const result = await login(email, password);
    if (result instanceof Error) {
      setError(result.message);
      alert(`Erro ao fazer login: ${result.message}`);
    } else {
      navigate('/'); // ou o caminho desejado
    }
  };

  return (
    <div className='flex flex-col min-h-screen bg-indigo-200 justify-center items-center'>
      <Card className="w-[450px] h-[400px]">
        <CardHeader>
          <CardTitle>Já tem cadastro?</CardTitle>
          <CardDescription>Faça o seu login</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSignIn}>
            <div className="grid w-full items-center gap-6">
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="email">Usuário</Label>
                <Input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Endereço de email"
                  required
                />
              </div>
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="senha">Senha</Label>
                <Input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="Senha"
                  required
                />
              </div>
              <CardFooter className="mt-6 flex justify-center align-center">
                <Button
                  type="submit"
                  className="bg-indigo-500 hover:bg-indigo-800 w-[130px]"
                >
                  Entrar
                </Button>
              </CardFooter>
            </div>
          </form>
        </CardContent>
      </Card>
      <footer className="w-full p-4 text-center bg-indigo-200">
        <p className="text-xs text-gray-800">©wCRM Versão {appVersion}</p>
      </footer>
    </div>
  );
};

export default SignIn;